import { createBrowserRouter } from 'react-router-dom';
import datasources from './datasources';
import grantAccess from './grant-access';
import setup from './setup';
import admin from './admin';
import sharing from './sharing';
import publicDatasets from './public-datasets';
import embedded from './embedded';

export default createBrowserRouter([
  datasources,
  grantAccess,
  setup,
  admin,
  sharing,
  publicDatasets,
  embedded,
]);
